import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const timePickerDefaultVariants = {
  "showFooter": false
}
const timePickerCompoundVariants = []

const timePickerSlotNames = [
  [
    "root",
    "timePicker__root"
  ],
  [
    "body",
    "timePicker__body"
  ],
  [
    "timeArea",
    "timePicker__timeArea"
  ],
  [
    "highlightBar",
    "timePicker__highlightBar"
  ],
  [
    "colon",
    "timePicker__colon"
  ],
  [
    "column",
    "timePicker__column"
  ],
  [
    "columnRoot",
    "timePicker__columnRoot"
  ],
  [
    "columnScroll",
    "timePicker__columnScroll"
  ],
  [
    "columnItem",
    "timePicker__columnItem"
  ],
  [
    "footer",
    "timePicker__footer"
  ],
  [
    "buttonGroup",
    "timePicker__buttonGroup"
  ]
]
const timePickerSlotFns = /* @__PURE__ */ timePickerSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, timePickerDefaultVariants, getSlotCompoundVariant(timePickerCompoundVariants, slotName))])

const timePickerFn = memo((props = {}) => {
  return Object.fromEntries(timePickerSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const timePickerVariantKeys = [
  "showFooter"
]
const getVariantProps = (variants) => ({ ...timePickerDefaultVariants, ...compact(variants) })

export const timePicker = /* @__PURE__ */ Object.assign(timePickerFn, {
  __recipe__: false,
  __name__: 'timePicker',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: timePickerVariantKeys,
  variantMap: {
  "showFooter": [
    "true",
    "false"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, timePickerVariantKeys)
  },
  getVariantProps
})